import Image from 'next/legacy/image';

export default function WordpressAdd() {
  return (
    <li>
      <h3 id="paste-wordpress">Add it to Wordpress Page</h3>
      <p>
        In your page, add a new <code>Custom HTML</code> block and paste the above copied code.
      </p>
      <Image src="/guides/wordpress-add.png" width={1074} height={550} alt="paste" />
    </li>
  );
}
